'use client';

import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-full absolute inset-0 z-[250] flex flex-col items-center justify-center bg-slate-50 text-slate-800 p-6 text-center">
          <AlertTriangle className="w-12 h-12 text-amber-500 mb-4 animate-bounce shrink-0" />
          <h2 className="text-xl font-bold mb-2">Map Context Crashed</h2>
          <p className="text-sm text-slate-500 max-w-xs mb-6">
            The 3D WebGL map context was lost or crashed on your mobile device. Reload the page to resume.
          </p>
          <button
            onClick={this.handleReload}
            className="flex items-center gap-2 px-5 py-3 bg-slate-900 active:scale-95 active:bg-black text-white font-bold rounded-2xl shadow-md transition-all h-11 justify-center min-w-[140px]"
          >
            <RefreshCw className="w-4 h-4" />
            <span>Reload Map</span>
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
